import { gql } from "graphql-tag"

const image = gql`
  type ImageFormat {
    ext: String
    hash: String
    height: Int!
    mime: String
    filename: String!
    path: String
    size: Float
    url: String!
    width: Int!
  }

  type ImageFormats {
    large: ImageFormat
    medium: ImageFormat
    small: ImageFormat
    thumbnail: ImageFormat
    xlarge: ImageFormat
    xsmall: ImageFormat
  }

  input ImageAddInput {
    contentId: ID
    originalUrl: String
    role: String
  }

  input ImageUpdateInput {
    contentId: ID
    id: ID
    originalUrl: String
    role: String
  }

  type Image {
    alternativeText: String
    caption: String
    credit: String
    ext: String
    filename: String!
    formats: ImageFormats
    hash: String
    height: Int!
    id: ID!
    mime: String
    provider: String
    related: String
    size: Float
    url: String!
    width: Int!
  }

  type CriticImages {
    back: String
    front: String
    overview: String
    slip: String
    slipback: String
  }

  input CriticImagesInput {
    back: String
    front: String
    overview: String
    slip: String
    slipback: String
  }

  type CreateImagesGridResponse {
    imagesGridId: ID!
  }
`

export default image
